<template>
  <div class="logo">
    <router-link :to="{ name: 'dashboard' }">
      <img src="~@/assets/logo.png" alt="logo" />
      <h1 class="logo-title" v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Logo",
  components: {},
  props: {
    title: {
      type: String,
      default: "寻寓科技",
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
};
</script>
<style scoped>
.logo-title {
  /* overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 120px; */
}
</style>
